import { useRouter } from 'next/router';
import { useCountryInfo } from '@/quote/hooks/useCountryInfo';
import { JOVE_DEFAULT_LOCALE_COUNTRY, JOVE_LOCAL_LOCALE_COUNTRY_KEY } from '@jove-frontend/uikit';
import { forceModifyCountryCodeToLanguage } from '../util/country';

export const useQuoteLocale = () => {
  const router = useRouter();
  const { requestUserCountryCode } = useCountryInfo();
  const getCurrentUseCountryCode = async (config?: { countryCode?: string }) => {
    let country = JOVE_DEFAULT_LOCALE_COUNTRY;
    const { forceCountryCode, firstUseEnglishLanguage } = router.query;
    if (forceCountryCode) {
      // Query
      country = forceCountryCode as string;
    } else if (config?.countryCode) {
      // Validation
      country = config?.countryCode;
    } else if (localStorage?.getItem(JOVE_LOCAL_LOCALE_COUNTRY_KEY)) {
      // Local
      country = localStorage?.getItem(JOVE_LOCAL_LOCALE_COUNTRY_KEY);
    } else if (firstUseEnglishLanguage) {
      country = JOVE_DEFAULT_LOCALE_COUNTRY;
    } else {
      country = await requestUserCountryCode();
    }

    country = forceModifyCountryCodeToLanguage(country);
    const realProjectUseCountryCode = country || JOVE_DEFAULT_LOCALE_COUNTRY;
    localStorage?.setItem(JOVE_LOCAL_LOCALE_COUNTRY_KEY, realProjectUseCountryCode);

    return realProjectUseCountryCode;
  };

  return {
    getCurrentUseCountryCode,
  };
};
